import { API_BASES } from "@lib/constants";
import { postRequest } from "./request";

export const postPlayEventRequest = async (
	params: {
		item_id: number;
		play_timestamp: number;
		play_time_seconds: number;
		device_id: number;
		heatmap: string;
		stream_quality: string;
		offline: boolean;
	},
	accessToken: string,
) => {
	const url = "events/play/";
	return postRequest({
		url: url,
		data: params,
		apiBase: API_BASES.api4,
		accessToken: accessToken,
	});
};
